import { render, staticRenderFns } from "./UsuarioPerfilPage.vue?vue&type=template&id=1bf1b513"
import script from "./UsuarioPerfilPage.vue?vue&type=script&lang=js"
export * from "./UsuarioPerfilPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports